// @flow
import React, { Component } from 'react';

import DoctorNotes from './DoctorNotes.jsx';
import LabResults from './LabResults.jsx';
import Xrays from './Xrays.jsx';
import CTScans from './CTScans.jsx';
import Ultrasounds from './Ultrasounds.jsx';
import OtherImagingReports from './OtherImagingReports.jsx';
import SocialWorks from './SocialWork.jsx';
import MiscReports from './MiscReports.jsx';

import PageHeader from '../../PageHeader.jsx';
import ContentBox from '../../ContentBox.jsx';

class ExternalReportsPage extends Component<{}> {
  render() {
    return (
      <div>
        <PageHeader title="External Reports" />
        <ContentBox title="Doctor's Notes and Referrals" id='doctor'>
          <DoctorNotes />
        </ContentBox>
        <ContentBox title="Laboratory Results" id='labResults'>
          <LabResults />
        </ContentBox>
        <ContentBox title="X-Rays" id='xrays'>
          <Xrays />
        </ContentBox>
        <ContentBox title="CT Scans" id='ctscans'>
          <CTScans />
        </ContentBox>
        <ContentBox title="Ultrasounds" id='ultrasounds'>
          <Ultrasounds />
        </ContentBox>
        <ContentBox title="Other Imaging Reports" id='otherImagingReports'>
          <OtherImagingReports />
        </ContentBox>
        <ContentBox title="Social Work" id='socialwork'>
          <SocialWorks />
        </ContentBox>
        <ContentBox title="Miscellaneous" id='misc'>
          <MiscReports />
        </ContentBox>
      </div>
    );
  }
}

export default ExternalReportsPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/externalReports/ExternalReportsPage.jsx